if (customElements.get('counter-timer')) {
  
}
class CounterTimer extends HTMLElement {
  constructor() {
    super();
    this.initSelectors();
    this.startTimer();
  }

  initSelectors() {
    this.daysElement = this.querySelector('#days span');
    this.hoursElement = this.querySelector('#hours span');
    this.minutesElement = this.querySelector('#minutes span');
    this.secondsElement = this.querySelector('#seconds span');
    this.daysLabel = this.querySelector('#days .smalltext');
    this.hoursLabel = this.querySelector('#hours .smalltext');
    this.minutesLabel = this.querySelector('#minutes .smalltext');
  }

  updateDate() {
    let today = new Date();

    let dayNum = today.getDate(),
      month = today.getMonth(),
      year = today.getFullYear();

    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // return value array with number as a index
    return `${dayNum} ${months[month]} ${year}`;
  }

  makeTimer() {
    var curdate = this.updateDate();

    var endTime = new Date(curdate + ' ' + this.dataset.timeEnd);
    endTime = Date.parse(endTime) / 1000;

    var now = new Date();
    now = Date.parse(now) / 1000;
    var timeLeft = endTime - now;

    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor((timeLeft - days * 86400) / 3600);
    var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
    var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    this.daysElement.textContent = days;
    this.hoursElement.textContent = hours;
    this.minutesElement.textContent = minutes;
    this.secondsElement.textContent = seconds;

   
  }

  startTimer() {
    this.initSelectors();
    this.makeTimer();
    setInterval(() => {
      this.makeTimer();
    }, 1000);
  }
}

customElements.define('counter-timer', CounterTimer);
